"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWebSocketChannel = void 0;
const react_1 = require("react");
const WebSocketContext_1 = require("./WebSocketContext");
const useWebSocketChannel = (channel, identifiers, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
channelCallback) => {
    const webSocketConnection = WebSocketContext_1.useWebSocketConnection();
    react_1.useEffect(() => {
        if (!webSocketConnection || !identifiers)
            return;
        webSocketConnection.registerForChannel(channel, identifiers, channelCallback);
        return () => {
            webSocketConnection.sendCommand(channel, identifiers, 'unsubscribe');
        };
    }, [webSocketConnection, channel, channelCallback, identifiers]);
};
exports.useWebSocketChannel = useWebSocketChannel;
